import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { speak } from '../utils/speak';

const API = '/api';

function Learn() {
  const [cards, setCards] = useState([]);
  const [current, setCurrent] = useState(0);
  const [flipped, setFlipped] = useState(false);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({ correct: 0, wrong: 0 });

  useEffect(() => {
    fetchDueCards();
  }, []);

  const fetchDueCards = async () => {
    try {
      const res = await axios.get(`${API}/cards/due`);
      setCards(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const handleAnswer = async (correct) => {
    const card = cards[current];
    try {
      await axios.put(`${API}/cards/${card.id}/level`, { correct });
    } catch (err) {
      console.error(err);
    }

    setStats(s => ({
      correct: correct ? s.correct + 1 : s.correct,
      wrong: correct ? s.wrong : s.wrong + 1,
    }));

    if (current + 1 >= cards.length) {
      setDone(true);
    } else {
      setCurrent(current + 1);
      setFlipped(false);
    }
  };

  const levelNames = { 1: 'Neu', 2: 'Anfänger', 3: 'Fortgeschritten', 4: 'Gut', 5: 'Gelernt' };

  if (loading) return <div className="card"><p>Lade Karten...</p></div>;

  if (cards.length === 0) return (
    <div>
      <h1>Lernen</h1>
      <div className="card" style={{ textAlign: 'center', color: '#718096' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🎉</div>
        <h2>Alle Karten gelernt!</h2>
        <p>Heute sind keine Karten fällig. Morgen geht es weiter!</p>
      </div>
    </div>
  );

  if (done) return (
    <div>
      <h1>Lernen</h1>
      <div className="card" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
        <h2>Runde beendet!</h2>
        <p style={{ margin: '1rem 0' }}>
          <span style={{ color: '#48bb78', fontWeight: '600' }}>✓ {stats.correct} richtig</span>
          {'  '}
          <span style={{ color: '#fc8181', fontWeight: '600' }}>✗ {stats.wrong} falsch</span>
        </p>
        <button className="btn-primary" onClick={() => {
          setCurrent(0); setFlipped(false); setDone(false);
          setStats({ correct: 0, wrong: 0 }); fetchDueCards();
        }}>
          Nochmal lernen
        </button>
      </div>
    </div>
  );

  const card = cards[current];

  return (
    <div>
      <h1>Lernen</h1>
      <p style={{ color: '#718096', marginBottom: '1rem' }}>
        Karte {current + 1} von {cards.length}
      </p>

      <div className="card" style={{ textAlign: 'center', minHeight: '200px' }}>
        <span className={`level-badge level-${card.level}`} style={{ marginBottom: '1.5rem', display: 'inline-block' }}>
          Stufe {card.level} — {levelNames[card.level]}
        </span>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.75rem', margin: '1rem 0' }}>
          <div style={{ fontSize: '2rem', fontWeight: '700' }}>{card.word}</div>
          <button onClick={() => speak(card.word, card.source_lang)}
            style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer' }}
            title="Aussprechen">🔊</button>
        </div>
        <div style={{ fontSize: '0.9rem', color: '#718096' }}>
          {card.source_lang} → {card.target_lang}
        </div>

        {!flipped ? (
          <button className="btn-primary" style={{ marginTop: '2rem' }} onClick={() => setFlipped(true)}>
            Übersetzung zeigen
          </button>
        ) : (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.75rem', margin: '1.5rem 0' }}>
              <div style={{ fontSize: '2rem', fontWeight: '700', color: '#4c51bf' }}>{card.translation}</div>
              <button onClick={() => speak(card.translation, card.target_lang)}
                style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer' }}
                title="Aussprechen">🔊</button>
            </div>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', marginTop: '1rem' }}>
              <button className="btn-danger" onClick={() => handleAnswer(false)}>
                ✗ Nicht gewusst
              </button>
              <button className="btn-success" onClick={() => handleAnswer(true)}>
                ✓ Gewusst
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Learn;